var styles = {"mBreakpointMd":"(min-width: 960px)","page":"styles_page__1sxvK flex flex-auto flex-column","header":"styles_header__QUgrd","placement-default":"styles_placement-default__4MBe1","placementDefault":"styles_placement-default__4MBe1","body":"styles_body__3gcFy"};

export default styles;
//# sourceMappingURL=styles.css.js.map
